import { __assign } from "tslib";
export function createMask(group, maskType, maskAttrs) {
    var maskShape = group.addShape({
        type: maskType,
        name: 'component-mask',
        attrs: __assign({ fill: '#569CFF', opacity: 0.16 }, maskAttrs),
    });
    return maskShape;
}
export function updateMask(shape, maskAttrs) {
    shape.attr(maskAttrs);
    return shape;
}
export function getRectMaskAttrs(start, end) {
    var x = Math.min(start.x, end.x);
    var y = Math.min(start.y, end.y);
    var width = Math.abs(end.x - start.x);
    var height = Math.abs(end.y - start.y);
    return {
        x: x,
        y: y,
        width: width,
        height: height,
    };
}
//# sourceMappingURL=mask.js.map